(() => {
  const main=document.querySelector('#MainContent');
  if(!main || main.dataset.motionV2) return;
  main.dataset.motionV2='true';
  const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine=matchMedia('(hover:hover) and (pointer:fine)').matches;
  let images={};try{images=JSON.parse(document.querySelector('#homepage-motion-images')?.textContent||'{}');}catch{}
  main.querySelectorAll('product-card').forEach(card=>{
    const gallery=card.querySelector('.card-gallery');
    const href=card.querySelector('a[href*="/products/"]')?.getAttribute('href');
    const handle=href?.split('/products/')[1]?.split(/[?#]/)[0];
    if(!gallery)return;
    gallery.classList.add('dy-motion-gallery');
    const label=document.createElement('span');label.className='dy-motion-view';label.textContent='View product ↗';label.setAttribute('aria-hidden','true');gallery.append(label);
    if(fine && images[handle]){
      const img=document.createElement('img');img.className='dy-motion-second';img.alt='';img.loading='lazy';img.decoding='async';img.src=images[handle];
      img.addEventListener('load',()=>gallery.classList.add('dy-second-ready'),{once:true});gallery.append(img);
    }
  });
  if(reduced || !('IntersectionObserver' in window))return;
  const targets=main.querySelectorAll('.dy-category-editorial__item, product-card, .dy-category-editorial__header');
  const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
    if(entry.isIntersecting){entry.target.classList.add('dy-motion-entered');observer.unobserve(entry.target);}
  }),{threshold:.08});
  targets.forEach((node,i)=>{node.style.setProperty('--dy-delay',`${i%4*65}ms`);observer.observe(node);});
  // Never hide content while waiting for JS or an observer.
  const hero=main.firstElementChild;hero?.classList.add('dy-hero-enter');
})();
